// 공지사항 번역 및 상수
import type { Locale } from '@/config/locales';
import type { AnnouncementTranslations, Language, Announcement } from './types';

// #522 — Locale 단일 출처 정합 (15언어 전수). 누락 시 컴파일 에러.
export const announcementTranslations:
  & Record<Language, AnnouncementTranslations>
  & Record<Exclude<Locale, Language>, AnnouncementTranslations> = {
  ko: {
    title: '공지사항',
    all: '전체',
    system: '시스템',
    event: '이벤트',
    update: '업데이트',
    noAnnouncements: '공지사항이 없습니다',
    readMore: '더보기',
    new: '새글',
  },
  es: {
    title: 'Anuncios',
    all: 'Todos',
    system: 'Sistema',
    event: 'Evento',
    update: 'Actualización',
    noAnnouncements: 'No hay anuncios',
    readMore: 'Leer más',
    new: 'Nuevo',
  },
  en: {
    title: 'Announcements',
    all: 'All',
    system: 'System',
    event: 'Event',
    update: 'Update',
    noAnnouncements: 'No announcements',
    readMore: 'Read more',
    new: 'New',
  },
  pt: {
    title: 'Avisos',
    all: 'Todos',
    system: 'Sistema',
    event: 'Evento',
    update: 'Atualização',
    noAnnouncements: 'Não há avisos',
    readMore: 'Ler mais',
    new: 'Novo',
  },
  fr: {
    title: 'Annonces',
    all: 'Tous',
    system: 'Système',
    event: 'Événement',
    update: 'Mise à jour',
    noAnnouncements: 'Aucune annonce',
    readMore: 'Lire la suite',
    new: 'Nouveau',
  },
  zh: {
    title: '公告',
    all: '全部',
    system: '系统',
    event: '活动',
    update: '更新',
    noAnnouncements: '暂无公告',
    readMore: '查看更多',
    new: '新',
  },
  ja: {
    title: 'お知らせ',
    all: 'すべて',
    system: 'システム',
    event: 'イベント',
    update: 'アップデート',
    noAnnouncements: 'お知らせはありません',
    readMore: 'もっと見る',
    new: '新着',
  },
  hi: {
    title: 'घोषणाएँ',
    all: 'सभी',
    system: 'सिस्टम',
    event: 'इवेंट',
    update: 'अपडेट',
    noAnnouncements: 'कोई घोषणा नहीं है',
    readMore: 'और पढ़ें',
    new: 'नया',
  },
  de: {
    title: 'Ankündigungen',
    all: 'Alle',
    system: 'System',
    event: 'Event',
    update: 'Aktualisierung',
    noAnnouncements: 'Keine Ankündigungen',
    readMore: 'Mehr lesen',
    new: 'Neu',
  },
  it: {
    title: 'Annunci',
    all: 'Tutti',
    system: 'Sistema',
    event: 'Evento',
    update: 'Aggiornamento',
    noAnnouncements: 'Nessun annuncio',
    readMore: 'Leggi di più',
    new: 'Nuovo',
  },
  ru: {
    title: 'Объявления',
    all: 'Все',
    system: 'Система',
    event: 'Событие',
    update: 'Обновление',
    noAnnouncements: 'Объявлений нет',
    readMore: 'Читать далее',
    new: 'Новое',
  },
  ar: {
    title: 'الإعلانات',
    all: 'الكل',
    system: 'النظام',
    event: 'فعالية',
    update: 'تحديث',
    noAnnouncements: 'لا توجد إعلانات',
    readMore: 'اقرأ المزيد',
    new: 'جديد',
  },
  vi: {
    title: 'Thông báo',
    all: 'Tất cả',
    system: 'Hệ thống',
    event: 'Sự kiện',
    update: 'Cập nhật',
    noAnnouncements: 'Không có thông báo',
    readMore: 'Xem thêm',
    new: 'Mới',
  },
  th: {
    title: 'ประกาศ',
    all: 'ทั้งหมด',
    system: 'ระบบ',
    event: 'กิจกรรม',
    update: 'อัปเดต',
    noAnnouncements: 'ไม่มีประกาศ',
    readMore: 'อ่านเพิ่มเติม',
    new: 'ใหม่',
  },
  nl: {
    title: 'Aankondigingen',
    all: 'Alle',
    system: 'Systeem',
    event: 'Evenement',
    update: 'Update',
    noAnnouncements: 'Geen aankondigingen',
    readMore: 'Lees meer',
    new: 'Nieuw',
  },
};

// #71: 초기 공지사항 - 목데이터 제거, API 연동은 별도 이슈
// #522: 시그니처 Locale 로 확장 (Language ⊂ Locale 하위 호환)
export function createInitialAnnouncements(_locale: Locale): Announcement[] {
  return [];
}
